import React from 'react'
import Layout from './../../components/help/Layout/Layout'
import Seo from '../../components/help/Seo'
import Header from '../../components/ui/Header/Header'
import HeaderFixed from './../../components/ui/HeaderFixed/HeaderFixed'
import PageNavigation from '../../components/ui/PageNavigation/PageNavigation'
import { getHrefToHome } from '../../utils/getHrefToHome'
import { graphql, useStaticQuery } from 'gatsby'
import CorporateGovernance from '../../components/pages/CorporateGovernance/CorporateGovernance'

const CorporateGovernancePage = () => {
    const lang = 'hy'
    const hrefHome = getHrefToHome(lang)

    const data = useStaticQuery(graphql`
        {
            title: datoCmsRenshinPageCorporateGovernance(title: { eq: "Title" }, locale: { eq: "hy" }) {
                value
            }

            text: datoCmsRenshinPageCorporateGovernance(title: { eq: "Text" }, locale: { eq: "hy" }) {
                value
            }

            location: datoCmsRenshinPageCorporateGovernance(title: { eq: "Text: Location" }, locale: { eq: "hy" }) {
                value
            }

            moreText: datoCmsRenshinPageCorporateGovernance(title: { eq: "More" }, locale: { eq: "hy" }) {
                value
            }

            lessText: datoCmsRenshinPageCorporateGovernance(title: { eq: "Less" }, locale: { eq: "hy" }) {
                value
            }

            items: allDatoCmsRenshinCorporateGovernanceSection(sort: { fields: sorting, order: ASC }, filter: { locale: { eq: "hy" } }) {
                nodes {
                    id
                    title
                    description
                    image {
                        url
                    }
                }
            }

            files: allDatoCmsRenshinCorporateGovernanceFile(filter: { locale: { eq: "hy" } }) {
                nodes {
                    name
                    section {
                        id
                    }
                    file {
                        url
                    }
                }
            }

            seo: datoCmsRenshinSeo(pageName: { eq: "Corporate governance" }, locale: { eq: "hy" }) {
                titleH1
                crumbsName
                footerLinks {
                    title
                    url
                }
                seo {
                    title
                    description
                }
            }

            main: datoCmsRenshinSeo(pageName: { eq: "Main" }, locale: { eq: "hy" }) {
                crumbsName
            }
        }
    `)

    const breadCrumbs = [
        { name: `${data.main.crumbsName}`, href: `${hrefHome}`, current: false },
        { name: `${data.seo.crumbsName}`, current: true }
    ]

    return (
        <Layout lang={lang}>
            <Seo
                title={data.seo.seo && data.seo.seo.title ? data.seo.seo.title : ''}
                description={data.seo.seo && data.seo.seo.description ? data.seo.seo.description : ''}
            />

            <Header lang={lang} />
            <HeaderFixed lang={lang} light />

            <CorporateGovernance
                crumbs={breadCrumbs}
                data={data}
                lang={lang}
                textLocation={data.location && data.location.value ? data.location.value : false}
                moreText={data.moreText?.value || 'More'}
                lessText={data.lessText?.value || 'Less'}
            />

            <PageNavigation links={data.seo.footerLinks} lang={lang} />
        </Layout>
    )
}

export default CorporateGovernancePage
